import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi,} from '@angular/common/http';
import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {APP_ROUTE} from './app.routes';
import {provideRouter} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {ErrorInterceptor} from '@core/interceptor/error.interceptor';
import {DirectionService, LanguageService} from '@core';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,} from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {FeatherModule} from 'angular-feather';
import {allIcons} from 'angular-feather/icons';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {JwtModule} from '@auth0/angular-jwt';
import {environment} from '@enviroment/environment';
import {AuthInterceptor} from "@core/interceptor/auth.interceptor";
import {decryptData} from "@shared/utils/decrypt";
import { RequestDedupInterceptor } from '@core/interceptor/request-dedup.interceptor';
import { APP_INITIALIZER } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/es';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getMatPaginatorIntlEs} from "@core/i18n/mat-paginator-es";


export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initDateLocale(dateAdapter: DateAdapter<any>) {
  return () => {
    // Fuerza Moment a español
    moment.locale('es');

    // Fuerza el DateAdapter (Angular Material) a español
    dateAdapter.setLocale('es-MX');
  };
}

export function tokenGetter(): string | null {
  try {
    const raw =
      sessionStorage.getItem(environment.cypher_key) ||
      localStorage.getItem(environment.cypher_key);

    if (!raw || raw === 'null' || raw === 'undefined') {
      return null;
    }

    const decrypted = decryptData(raw, environment.encryptionKey);

    if (!decrypted) return null;
    return decrypted;
  } catch {
    return null;
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    // HttpClient (solo una vez). Los interceptores DI se enganchan con withInterceptorsFromDi().
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(APP_ROUTE),
    provideAnimations(),
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    DirectionService,
    LanguageService,

    { provide: MatPaginatorIntl, useFactory: getMatPaginatorIntlEs },

    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter,
          allowedDomains: [environment.allowed_token_domain],
          disallowedRoutes: [
            environment.backend_url + 'Auth/login',
            environment.backend_url + 'Auth/forgot-password',
            environment.backend_url + 'Auth/reset-password',
            environment.backend_url + 'Auth/renew',
          ],
        },
      })
    ),
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initDateLocale,
      deps: [DateAdapter],
      multi: true,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: { dateInput: 'YYYY-MM-DD' },
        display: {
          dateInput: 'YYYY-MM-DD',
          monthYearLabel: 'YYYY MMM',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'YYYY MMM',
        },
      },
    },
    importProvidersFrom(FeatherModule.pick(allIcons)),
    provideCharts(withDefaultRegisterables()),
    // Interceptor global anti-doble-click / anti-doble-request
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestDedupInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideAnimationsAsync(),
  ],
};

